import React from 'react';
import './Spinner.css';

export interface SpinnerProps {
  /** Whether the spinner is visible; if false, renders null. */
  visible?: boolean;
  /** Optional text to display next to the spinner. */
  text?: string;
  /** ARIA label for the spinner itself (defaults to 'Loading'). */
  ariaLabel?: string;
  /** Additional class names for the outer wrapper. */
  className?: string;
  /** Size variant: 'sm' | 'md' | 'lg'. */
  size?: 'sm' | 'md' | 'lg';
  /** Whether to center contents inline (flex). */
  inline?: boolean;
}

/**
 * Reusable spinner component with optional descriptive text.
 * Uses Bootstrap's spinner-border classes. Size prop adjusts spinner dimensions.
 */
const Spinner: React.FC<SpinnerProps> = ({
  visible = true,
  text,
  ariaLabel = 'Loading',
  className = '',
  size = 'md',
  inline = false,
}) => {
  if (!visible) {
    return null;
  }

  const sizeClass = size === 'sm' ? 'spinner-border-sm' : '';
  const sizeClassName = size === 'lg' ? 'spinner-lg' : '';

  return (
    <div
      className={`d-flex ${inline ? 'align-items-center' : 'chat-spinner-center'}  gap-3 ${className}`.trim()}
      aria-live="polite"
    >
      <div
        className={`spinner-border text-primary ${sizeClass} ${sizeClassName}`.trim()}
        role="status"
        aria-label={ariaLabel}
      />
      {text && <span className="text-muted fs-5 mb-0">{text}</span>}
    </div>
  );
};

export default Spinner;
